module.exports = __webpack_public_path__ + "static/media/191CS164.9fb1b812.jpg";